import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import BannerCard from '../muvicard/components/banner-card/banner-card.component'
import ContentCard from '../muvicard/components/content-card/content-card.component'
import { toastActions } from '../../actions'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { bindActionCreators } from 'redux'

class MuvicardCancelPage extends Component {
	render() {
		const { user, toastSuccess, toastError } = this.props

		return (
			<section>
				<BannerCard logged={user} />{' '}
				<ContentCard isCancelPage={true} toastSuccess={toastSuccess} toastError={toastError} />
			</section>
		)
	}
}

const mapStateToProps = store => ({
	user: store.user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedMuvicardCancelPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MuvicardCancelPage)
)
export { connectedMuvicardCancelPage as ModuleRootComponent }
